import { RootState } from "store";
import { SerializedDevice } from ".";
import {
  selectActiveAudioInput,
  selectActiveAudioOutput,
  selectActiveVideoInput,
  selectAudioInputDevicesWithLabels,
  selectAudioOutputDevicesWithLabels,
  selectVideoInputDevicesWithLabels,
  setActiveAudioInput,
  setActiveAudioOutput,
  setActiveVideoInput,
} from "./slice";
import { DeviceType } from "./types";

export const DEVICE_TYPES = [
  "audioInput",
  "audioOutput",
  "videoInput",
] as const;

export const VIDEO_PRE_ENABLED_KEY = "video-pre-enabled";
export const AUDIO_PRE_ENABLED_KEY = "audio-pre-enabled";

export const STORAGE_KEY_BY_DEVICE_TYPE: Readonly<Record<DeviceType, string>> =
  {
    audioInput: "microphoneDevice",
    audioOutput: "speakerDevice",
    videoInput: "cameraDevice",
  };

export const DEVICES_SELECTOR_BY_DEVICE_TYPE: Readonly<
  Record<DeviceType, (state: RootState) => MediaDeviceInfo[]>
> = {
  audioInput: selectAudioInputDevicesWithLabels,
  audioOutput: selectAudioOutputDevicesWithLabels,
  videoInput: selectVideoInputDevicesWithLabels,
};

export const ACTIVE_DEVICE_SELECTOR_BY_DEVICE_TYPE: Readonly<
  Record<DeviceType, (state: RootState) => SerializedDevice | null>
> = {
  audioInput: selectActiveAudioInput,
  audioOutput: selectActiveAudioOutput,
  videoInput: selectActiveVideoInput,
};

export const SET_ACTIVE_DEVICE_ACTION_BY_DEVICE_TYPE = {
  audioInput: setActiveAudioInput,
  audioOutput: setActiveAudioOutput,
  videoInput: setActiveVideoInput,
} as const;

export const DEVICE_KIND_BY_DEVICE_TYPE: Readonly<
  Record<DeviceType, MediaDeviceKind>
> = {
  audioInput: "audioinput",
  audioOutput: "audiooutput",
  videoInput: "videoinput",
};
